import { render } from "./RequirementReplies.vue?vue&type=template&id=8ba15628&scoped=true"
import script from "./RequirementReplies.vue?vue&type=script&lang=js"
export * from "./RequirementReplies.vue?vue&type=script&lang=js"

import "./RequirementReplies.vue?vue&type=style&index=0&id=8ba15628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba15628"]])

export default __exports__